import React, { useState, useEffect} from 'react';
import { PropTypes } from 'prop-types';
import { RequiredValidation, RadioGroupWithValidation, Radio, Heading, Box } from 'sarsaparilla';
import { get, isObject } from 'lodash';

import { MAX_STOCK_KEY_NAME, IS_BRINGING_ANIMALS_EMPTY } from 'ui-permit/src/constants';
import { hasRule, readRuleValue } from 'ui-permit/src/utils/utils';
import { PERMIT as permitProps } from 'ui-permit/src/props/permit';

import { DEFAULT_MAX_STOCK } from '../constants';
import { IS_BRINGING_ANIMALS_PROP_PATH } from '../constants/propPaths';

const defaultDataBindingMap = {
  [IS_BRINGING_ANIMALS_PROP_PATH]: 'is_bringing_animals'
};
const defaultAttributes = {};

export default (issuanceShape, dataBindingsMap = defaultDataBindingMap, attributes = defaultAttributes) => {
  const propTypes = {
    validation: PropTypes.shape().isRequired,
    reservation: issuanceShape,
    pActions: PropTypes.shape({
      formValidationChange: PropTypes.func.isRequired,
      updatePendingReservation: PropTypes.func.isRequired
    }).isRequired,
    displayValidationError: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    permit: permitProps,
    rules: PropTypes.array,
    name: PropTypes.string,
    addFieldRef: PropTypes.func,
  };
  const defaultProps = {
    permit: {},
    reservation: {}
  };

  function BringAnimalQuestion({
    name,
    permit,
    reservation,
    pActions,
    validation,
    displayValidationError,
    isReadOnly,
    addFieldRef,
  }) {
    const [maxNumAnimals, setMaxNumAnimals] = useState(DEFAULT_MAX_STOCK);

    useEffect(() => {
      if(hasRule(MAX_STOCK_KEY_NAME, permit.rules, reservation.division_id)) {
        setMaxNumAnimals(Number(readRuleValue(MAX_STOCK_KEY_NAME, permit.rules, reservation.division_id)))
      }
    }, [permit.rules, reservation.division_id])

    const onFormValidate = (isInValid, error) => {
      const path = IS_BRINGING_ANIMALS_EMPTY;
      if (isInValid) {
        pActions.formValidationChange(`${reservation.id}_${path}`, error);
      }
      else {
        pActions.formValidationChange(`${reservation.id}_${path}`, null);
      }
    };

    const handleIsBringAnimalChange = ({ target }) => {
      const { value } = target;
      const { id } = reservation;
      pActions.updatePendingReservation(id, dataBindingsMap[IS_BRINGING_ANIMALS_PROP_PATH], value === 'yes');
    };

    const isBringingAnimals = get(reservation, dataBindingsMap[IS_BRINGING_ANIMALS_PROP_PATH]);
    let bringingAnimal = ''
    if (maxNumAnimals === 0 || isBringingAnimals === false) {
      bringingAnimal = 'no'
    }
    else if(isBringingAnimals) {
      bringingAnimal = 'yes'
    }

    let validationHighlight = '';
    if (isObject(get(validation, `${reservation.id}_${IS_BRINGING_ANIMALS_EMPTY}`)) && displayValidationError) {
      validationHighlight = 'permit-validation-highlight';
    }

    return (
      <Box className={`${validationHighlight} mb-2`}>
        <Heading headingLevel={2} appearance="h5">
          Animals
        </Heading>
        <RadioGroupWithValidation
          ref={addFieldRef?.(name, 0)}
          id="bringing-animal-radio-group"
          name="bringing-animal-radio-group"
          label="Are you bringing animals on your trip?"
          value={bringingAnimal}
          isDisabled={isReadOnly || maxNumAnimals === 0}
          isLabelVisible
          isRequired
          isInline
          onChange={handleIsBringAnimalChange}>
          <Radio id="bringing-animal-yes" label="Yes" value="yes" />
          <Radio id="bringing-animal-no" label="No" value="no" />
        </RadioGroupWithValidation>
        <RequiredValidation
          value={bringingAnimal}
          displayInSummary
          onValidated={onFormValidate}
          controlLabel="Answer to Bringing Animal Question"
        />
      </Box>
    );
  }

  BringAnimalQuestion.propTypes = propTypes;
  BringAnimalQuestion.attributes = attributes;
  BringAnimalQuestion.defaultProps = defaultProps;

  return BringAnimalQuestion;
};
